import React,{useState} from "react";
import { Field } from "formik";

export const FlourFancy = ({formik,naturalFancyData,language}) => {

    const [flouData,setFlouData] =useState(naturalFancyData.length !== 0 && naturalFancyData[0].fluorescence !== null ? naturalFancyData[0].fluorescence : [])
    const newFlouData =flouData.length!==0 ? flouData.split(',').map((value,index) => {
        return {
            id: index,
            value:value,
            flour: value
            // flour: value === "NON" ? "NONE" :
            //     value === "FNT" ? "FAINT" :
            //     value === "VSLT" ? "VERY SLIGHT" :
            //     value === "SLT" ? "SLIGHT" :
            //     value === "MED" ? "MEDIUM" :
            //     value === "STG" ? "STRONG" :
            //     value === "VST" ? "VERY STRONG" :
            //     value  
        }
    }):null

    // const flourData = ([
    //     {
    //         id: 1,
    //         value:"NON",
    //         flour:"NONE"
    //     },
    //     {
    //         id: 2,
    //         value:"FNT",
    //         flour:"FAINT"
    //     },
    //     {
    //         id: 3,
    //         value:"VSLT",
    //         flour:"VERY SLIGHT"
    //     },
    //     {
    //         id: 4,
    //         value:"SLT",
    //         flour:"SLIGHT"
    //     },
    //     {
    //         id: 5,
    //         value:"MED",
    //         flour:"MEDIUM"
    //     },
    //     {
    //         id: 6,
    //         value:"STG",
    //         flour:"STRONG"
    //     },
    //     {
    //         id: 7,
    //         value:"VST",
    //         flour:"VERY STRONG"
    //     }
    // ]);

    return (
        <>
            <div className="row mt-5 pb-8 border-bottom">
                <div className="col-lg-2">
                    <p className="font-size-h6">{language.CCMODE_THEME1_SEARCHDIAMOND_FLUORESCENCE}</p>
                </div>
                <div className="col-lg-10 d-flex flex-wrap">
                    {newFlouData ? newFlouData.map((item) => (
                        <label key={item.id} className="search_btn_check">
                            <Field type="checkbox" name="Fluorescence_Intensity" id={`${item.flour}_flour`} value={item.value}/>
                            <div className="finishBox selectBox">
                                <span>{item.flour}</span>
                            </div>
                        </label>
                    )):null}
                </div>
            </div>
        </>
    );
};